import { render, staticRenderFns } from "./die-selection-rule.vue?vue&type=template&id=cbfffbf6&scoped=true&"
import script from "./die-selection-rule.vue?vue&type=script&lang=js&"
export * from "./die-selection-rule.vue?vue&type=script&lang=js&"
import style0 from "./die-selection-rule.vue?vue&type=style&index=0&id=cbfffbf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbfffbf6",
  null
  
)

export default component.exports